module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genLocalLicense"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('h2', [_vm._v("License Form")]), _vm._v(" "), _c('el-form', {
    ref: "newLicenseForm",
    attrs: {
      "label-position": "left",
      "model": _vm.newLicenseForm,
      "rules": _vm.genRules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Project Name",
      "prop": "project"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.project),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "project", $$v)
      },
      expression: "newLicenseForm.project"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Direct Customer",
      "prop": "direct_cus"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Please Select",
      "filter-method": _vm.handleCustomerAutoComplete
    },
    on: {
      "change": _vm.handleCustomerInputChange,
      "focus": _vm.getCustomerDataList
    },
    model: {
      value: (_vm.newLicenseForm.direct_cus),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "direct_cus", $$v)
      },
      expression: "newLicenseForm.direct_cus"
    }
  }, _vm._l((_vm.customerData.cus_list), function(item) {
    return _c('el-option', {
      key: item.cus_id,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "End Customer",
      "prop": "end_cus"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.end_cus),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "end_cus", $$v)
      },
      expression: "newLicenseForm.end_cus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expiry Date [as UTC(+00:00)]",
      "prop": "exp_date"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Select Date",
      "default-value": new Date(),
      "value-format": "yyyy-MM-ddTHH:mm:ss.000Z",
      "disabled": _vm.datePickerDisable
    },
    on: {
      "change": _vm.OnExpiryDateChange
    },
    model: {
      value: (_vm.tmp_exp_date),
      callback: function($$v) {
        _vm.tmp_exp_date = $$v
      },
      expression: "tmp_exp_date"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.OnCheckBoxChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("No Limit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer Email",
      "prop": "user_email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.newLicenseForm.user_email),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "user_email", $$v)
      },
      expression: "newLicenseForm.user_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "ER Number",
      "prop": "er_num"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "placeholder": "Enter ER Number"
    },
    model: {
      value: (_vm.newLicenseForm.er_num),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "er_num", $$v)
      },
      expression: "newLicenseForm.er_num"
    }
  }, _vm._l((_vm.er_options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "disabled": "",
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "NE Point",
      "prop": "ne_point"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": ""
    },
    model: {
      value: (_vm.newLicenseForm.ne_point),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "ne_point", $$v)
      },
      expression: "newLicenseForm.ne_point"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Enable White Label",
      "prop": "white_label"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.newLicenseForm.white_label),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "white_label", $$v)
      },
      expression: "newLicenseForm.white_label"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PI Number",
      "prop": "pi_num"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.pi_num),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "pi_num", $$v)
      },
      expression: "newLicenseForm.pi_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Support Duration",
      "prop": "support_dr"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number",
      "min": "0"
    },
    on: {
      "change": _vm.OnSupportDrChange,
      "blur": _vm.OnSupportDrChange
    },
    model: {
      value: (_vm.newLicenseForm.support_dr),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "support_dr", $$v)
      },
      expression: "newLicenseForm.support_dr"
    }
  }), _vm._v("\n        (years)\n        "), _c('br'), _c('small', {
    staticStyle: {
      "text-align": "left",
      "color": "slateblue"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.newLicenseForm.support_dr_date == null ? "" : _vm.newLicenseForm.support_dr_date.format("DD MMM YYYY")) + "\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sales Name",
      "prop": "sales"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.sales),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "sales", $$v)
      },
      expression: "newLicenseForm.sales"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sales Email",
      "prop": "sales_email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.sales_email),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "sales_email", $$v)
      },
      expression: "newLicenseForm.sales_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.genLocalLicense
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('generate')
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454cbe1c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GenLocalLicense.vue
// module id = YC/v
// module chunks = 1